/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerBedRoom } from './ScreenerBedRoom';
import {
    ScreenerBedRoomFromJSON,
    ScreenerBedRoomFromJSONTyped,
    ScreenerBedRoomToJSON,
    ScreenerBedRoomToJSONTyped,
} from './ScreenerBedRoom';

/**
 * 
 * @export
 * @interface ScreenerBedUnit
 */
export interface ScreenerBedUnit {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    rank?: number;
    /**
     * 
     */
    rooms?: Array<ScreenerBedRoom>;
}

/**
 * Check if a given object implements the ScreenerBedUnit interface.
 */
export function instanceOfScreenerBedUnit(value: object): value is ScreenerBedUnit {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ScreenerBedUnitFromJSON(json: any): ScreenerBedUnit {
    return ScreenerBedUnitFromJSONTyped(json, false);
}

export function ScreenerBedUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerBedUnit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_id': json['facility_id'],
        'name': json['name'],
        'rank': json['rank'] == null ? undefined : json['rank'],
        'rooms': json['rooms'] == null ? undefined : ((json['rooms'] as Array<any>).map(ScreenerBedRoomFromJSON)),
    };
}

export function ScreenerBedUnitToJSON(json: any): ScreenerBedUnit {
    return ScreenerBedUnitToJSONTyped(json, false);
}

export function ScreenerBedUnitToJSONTyped(value?: ScreenerBedUnit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'name': value['name'],
        'rank': value['rank'],
        'rooms': value['rooms'] == null ? undefined : ((value['rooms'] as Array<any>).map(ScreenerBedRoomToJSON)),
    };
}

